import * as Sentry from '@sentry/react'
import { Alert, Typography } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface ErrorProps {
  error: any
}
const Error: React.FC<ErrorProps> = ({ error }): JSX.Element => {
  const { t } = useTranslation()

  useEffect(() => {
    if (error) {
      console.error(error)
      Sentry.captureException(error)
    }
  }, [error])

  return (
    <Alert
      message={
        <>
          <Typography.Text>{t('general.error', 'Something went wrong...')}</Typography.Text>
          <span>😞</span>
        </>
      }
      showIcon
      type={'error'}
      closable
    />
  )
}

export default Error
